import { render, staticRenderFns } from "./LegalAgreementDocument.vue?vue&type=template&id=fa5abc80&scoped=true&"
import script from "./LegalAgreementDocument.vue?vue&type=script&lang=js&"
export * from "./LegalAgreementDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5abc80",
  null
  
)

export default component.exports